// @vue/component
export default {
  name: 'MultipleSelect',

  props: {
    selectFor: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    uniqueKey: {
      type: [String, Number],
      default: 'uniqueKey',
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: 'value',
    },
    selectName: {
      type: String,
      default: 'selectName',
    },
    canSearch: {
      type: Boolean,
      default: true,
    },
    clearTooltipText: {
      type: String,
      default: 'Wyczyść listę',
    },
  },

  data() {
    return {
      filter: '',
    };
  },

  computed: {
    hasSelectedItem() {
      return this.selectedItems.length > 0;
    },
    filteredSelectFor() {
      return this.selectFor
        .filter((item) => {
          const labelInCollection = this.label ? item[this.label].toLowerCase() : '';
          const searchedWord = this.filter.toLowerCase();
          return labelInCollection.includes(searchedWord);
        });
    },
    numberOfSelectedElementsText() {
      let suffix = '';
      switch (this.selectedItems.length) {
        case 1:
          suffix = 'element';
          break;
        case 2:
        case 3:
        case 4:
          suffix = 'elementy';
          break;
        default:
          suffix = 'elementów';
          break;
      }
      return `Wybrano ${this.selectedItems.length} ${suffix}`;
    },
  },

  methods: {
    handleSelect(selectedItem) {
      this.$emit('select', { selectedItem, name: this.selectName });
    },
    handleClear() {
      if (this.hasSelectedItem) {
        this.$emit('clear', { name: this.selectName });
      }
    },
    clearFilter() {
      this.filter = '';
    },
  },
};
